module.exports = __webpack_public_path__ + "static/media/the-washington-post.c68737e4.jpg";